export const AdShopTerms = {
  date: '2019-01-01',
  version: '3.0'
};
